import React from 'react';
import styled from 'styled-components';
import { calc4k } from '../utilities';
import { colors, gradient, padding } from '../GlobalStyle';

import InstaSvg from '../data/images/instagram.svg';

export default function( { title, images } ) {

    const outputImages = () => {
        let imageArray = [];
        images.forEach( ( image, index ) => {
            imageArray.push(
                <Image image={image} key={`social-image-${index}`}/>
            );
        } );
        return imageArray;
    };

    return (
        <Social>
            <SocialHead>
                <Title>
                    { title }
                </Title>
                <Instagram src={InstaSvg}/>
            </SocialHead>
            <Images>
                { outputImages() }
            </Images>
        </Social>
    );
}

const Social = styled.div`
    height: ${calc4k(970)};
    position: relative;
    z-index: 0;   
    padding: 0 ${padding.side};
    background-color: black;
`;

const SocialHead = styled.div`
    display: flex;
    justify-content: space-between;
    padding: ${calc4k(70)} 0;
`;

const Instagram = styled.img`
    width: ${calc4k(70)};
    height: ${calc4k(70)};
`;

const Title = styled.h3`
    font-size: ${calc4k(65)};
`;

const Images = styled.div`
    display: flex;
    justify-content: space-between;
`;

const Image = styled.div`
    background-image: url(${ p => p.image });
    background-size: cover;
    width: calc( 33.33% - ${calc4k(2)} );
    height: ${calc4k(650.5)};
`;